import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small className="BreadCrumbs_style">Terms Of Use</small>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col md={12} xl={12}>
              <Card className="box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Terms Of Use </b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className=" px-4 py-5">
                  <div className="Terms_card">
                    <p>
                      These terms and conditions (the "Terms and Conditions")
                      govern the use of www.LibertyPrograms.com (the "Site").
                      This Site is owned and operated by Liberty Programs Inc.
                      This Site is an ecommerce website.By using this Site, you
                      indicate that you have read and understand these Terms and
                      Conditions and agree to abide by them at all times.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Intellectual Property</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      All content published and made available on our Site is
                      the property of Liberty Programs and the Site's creators.
                      This includes, but is not limited to images, text, logos,
                      documents, downloadable files and anything that
                      contributes to the composition of our Site.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Acceptable Use</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      As a user of our Site, you agree to use our Site legally,
                      not to use our Site for illegal purposes, and not to:
                    </p>
                    <p className="text_muted">
                      Harass or mistreat other users of our Site;Violate the
                      rights of other users of our Site;Violate the intellectual
                      property rights of the Site owners or any third party to
                      the Site;Hack into the account of another user of the
                      Site;Act in any way that could be considered fraudulent;
                      orPost any material that may be deemed inappropriate or
                      offensive.
                    </p>
                    <p className="text_muted">
                      If we believe you are using our Site illegally or in a
                      manner that violates these Terms and Conditions, we
                      reserve the right to limit, suspend or terminate your
                      access to our Site. We also reserve the right to take any
                      legal steps necessary to prevent you from accessing our
                      Site.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">User Contributions</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Users may post the following information on our Site:
                    </p>
                    <p className="text_muted Grp_para">Photos;</p>
                    <p className="text_muted Grp_para">Videos;</p>
                    <p className="text_muted">and Public comments.</p>
                    <p className="text_muted">
                      By posting publicly on our Site, you agree not to act
                      illegally or violate these Terms and Conditions.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Accounts</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      When you create an account on our Site, you agree to the
                      following:
                    </p>
                    <p className="text_muted">
                      You are solely responsible for your account and the
                      security and privacy of your account, including passwords
                      or sensitive information attached to that account; andAll
                      personal information you provide to us through your
                      account is up to date, accurate, and truthful and that you
                      will update your personal information if it changes.
                    </p>
                    <p className="text_muted">
                      We reserve the right to suspend or terminate your account
                      if you are using our Site illegally or if you violate
                      these Terms and Conditions.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Sale of Software</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      These Terms and Conditions govern the sale of goods
                      available on our Site.
                    </p>
                    <p className="text_muted">
                      The following goods are available on our Site:
                    </p>
                    <p className="text_muted">Computer Software.</p>
                    <p className="text_muted">
                      These Terms and Conditions apply to all the goods that are
                      displayed on our Site at the time you access it. This
                      includes all products listed as being out of stock. All
                      information, descriptions, or images that we provide about
                      our goods are as accurate as possible. However, we are not
                      legally bound by such information, descriptions, or images
                      as we cannot guarantee the accuracy of all goods we
                      provide. You agree to purchase goods from our Site at your
                      own risk.
                    </p>
                    <p className="text_muted">
                      We reserve the right to modify, reject or cancel your
                      order whenever it becomes necessary. If we cancel your
                      order and have already processed your payment, we will
                      give you a refund equal to the amount you paid. You agree
                      that it is your responsibility to monitor your payment
                      instrument to verify receipt of any refund.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">
                        Third Party Goods and Services
                      </b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Our Site may offer goods and services from third parties.
                      We cannot guarantee the quality or accuracy of goods and
                      services made available by third parties on our Site.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">User Goods and Services</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Our Site allows users to sell goods and services. We do
                      not assume any responsibility for the goods and services
                      users sell on our Site. We cannot guarantee the quality or
                      accuracy of any goods and services sold by users on our
                      Site. However, if we are made aware that a user is
                      violating these Terms and Conditions, we reserve the right
                      to suspend or prohibit the user from selling goods and
                      services on our Site.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Payments</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      We accept the following payment methods on our Site:
                    </p>
                    <p className="text_muted Grp_para">Credit Card; </p>
                    <p className="text_muted">Debit.</p>
                    <p className="text_muted">
                      When you provide us with your payment information, you
                      authorize our use of and access to the payment instrument
                      you have chosen to use. By providing us with your payment
                      information, you authorize us to charge the amount due to
                      this payment instrument.If we believe your payment has
                      violated any law or these Terms and Conditions, we reserve
                      the right to cancel or reverse your transaction.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Shipping: Digital Delivery</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      At LibertyPrograms.com, all purchases are delivered
                      electronically, with immediate access provided upon
                      completion of the purchase. Delivery of license keys is
                      subject to unforeseen circumstances. Ensure you provide
                      accurate information to prevent any misdelivery. Liberty
                      Programs is not liable for any errors due to incorrect or
                      incomplete recipient information.
                    </p>
                    {/* <p className="text_muted">Electronic Delivery (Instant) </p>
                    <p className="text_muted">
                      Delivery will take place immediately upon purchase
                      completion. Delivery of licensing key times may vary due
                      to unforeseen circumstances.{" "}
                    </p>
                    <p className="text_muted">
                      You are responsible for paying any such duties or taxes.
                      Please contact your local customs office for more
                      information before making a purchase. We are not
                      responsible for the payment of any such duties or taxes
                      and are not liable for any failure by you to pay them.
                    </p>
                    <p className="text_muted">
                      You are required to provide us with a complete and
                      accurate delivery address, including the name of the
                      recipient. We are not liable for the delivery of your
                      goods to the wrong address or wrong person as a result of
                      you providing us with inaccurate or incomplete
                      information.
                    </p> */}
                    <h6 className="mt-4">
                      <b className="Under_line">Refunds</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Our 90-day refund policy applies to unused software
                      licenses purchased from our Site. To be eligible for a
                      refund, the license key must remain unrevealed in your
                      account area. Please note that refunds are not applicable
                      once the license key has been used to install the
                      software.
                    </p>
                    <p className="text_muted">
                      If the software is broken, doesn't match the description,
                      or does not meet your expectations, you can request a
                      refund within the 90-day timeframe. Also, if you change
                      your mind about the purchase, you can request a refund
                      provided the license key has not been used.
                    </p>
                    <p className="text_muted">
                      Refunds will be processed within 1-2 weeks of acceptance,
                      using the original method of payment. If the license key
                      does not work, we commit to provide a new key promptly.
                    </p>
                    <p className="text_muted">
                      Please note, there are no refunds on 'Final Sale' goods
                      and software licenses that have been revealed or used.
                    </p>
                    {/* <p className="text_muted">
                      Thank you for choosing LibertyPrograms.com.
                    </p> */}
                    {/* <p className="text_muted">
                      or Software does not meet the purchaser's expectations.
                    </p> */}
                    {/* <p className="text_muted">
                      Refunds do not apply to the following goods:
                    </p>
                    <p className="text_muted Grp_para">Software licenses;</p>
                    <p className="text_muted">Final Sale.</p>
                    <h6 className="mt-4">
                      <b className="Under_line">Consumer Protection Law</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Where the Consumer Protection Act, or any other consumer
                      protection legislation in your jurisdiction applies and
                      cannot be excluded, these Terms and Conditions will not
                      limit your legal rights and remedies under that
                      legislation. These Terms and Conditions will be read
                      subject to the mandatory provisions of that legislation.
                      If there is a conflict between these Terms and Conditions
                      and that legislation, the mandatory provisions of the
                      legislation will apply.
                    </p> */}
                    <h6 className="mt-4">
                      <b className="Under_line">Links to Other Websites</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Our Site contains links to third party websites or
                      services that we do not own or control. We are not
                      responsible for the content, policies, or practices of any
                      third party website or service linked to on our Site. It
                      is your responsibility to read the terms and conditions
                      and privacy policies of these third party websites before
                      using these sites.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Limitation of Liability</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Liberty Programs and our directors, officers, agents,
                      employees, subsidiaries, and affiliates will not be liable
                      for any actions, claims, losses, damages, liabilities and
                      expenses including legal fees from your use of the Site.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Indemnity</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      Except where prohibited by law, by using this Site you
                      indemnify and hold harmless Liberty Software and our
                      directors, officers, agents, employees, subsidiaries, and
                      affiliates from any actions, claims, losses, damages,
                      liabilities and expenses including legal fees arising out
                      of your use of our Site or your violation of these Terms
                      and Conditions.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Applicable Law</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      These Terms and Conditions are governed by the laws of the
                      State of New York.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Severability</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      If at any time any of the provisions set forth in these
                      Terms and Conditions are found to be inconsistent or
                      invalid under applicable laws, those provisions will be
                      deemed void and will be removed from these Terms and
                      Conditions. All other provisions will not be affected by
                      the removal and the rest of these Terms and Conditions
                      will still be considered valid.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Changes</b>
                    </h6>
                    <br />
                    <p className="text_muted">
                      These Terms and Conditions may be amended from time to
                      time in order to maintain compliance with the law and to
                      reflect any changes to the way we operate our Site and the
                      way we expect users to behave on our Site. We will notify
                      users by email of changes to these Terms and Conditions or
                      post a notice on our Site.
                    </p>
                    <h6 className="mt-4">
                      <b className="Under_line">Contact Details</b>
                    </h6>
                    <br />
                    <p className="text_muted Grp_para">
                      Please contact us if you have any questions or concerns.
                      Our contact details are as follows:
                    </p>
                    <p className="text_muted Grp_para">(833) 465 0300</p>
                    <p className="text_muted Grp_para">
                      admin@libertysoftware.com
                    </p>
                    <p className="text_muted">
                      {/* 1546 BW 56th Street, New York, NY 10009 */}
                      2248 Broadway #1721 <br /> New York, NY 10024 <br />{" "}
                      United States
                    </p>
                    <br />
                    <p className="text_muted ">
                      You can also contact us through the feedback form
                      available on our Site.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Terms;
